import classNames from 'classnames'

export function LoadingProgress({ className, ...rest }) {
  return <div {...rest} className={classNames(className, 'LoadingProgress')} />
}
